import React from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import { isWeb } from 'src/utils/platform';
import styleUtils from 'src/utils/styles';
import Column from '../../10-atoms/layout/Column';
import { usePageContext } from './PageContext';
const PageBody = ({ style, children, ...rest }) => {
    const { contentMaxWidth } = usePageContext();
    const [{ deviceType, theme }] = useTheme();
    const isDesktopWeb = isWeb && deviceType.isDesktop;
    if (isDesktopWeb && contentMaxWidth != null) {
        return (React.createElement(Column, { flex: true, xAxis: 'center', ph: theme.spacing.standard.sm, pv: theme.spacing.standard.sm, ...rest },
            React.createElement(Column, { bwd: 1, brd: theme.borderRadius.standard.md, style: [
                    styleUtils.containerHeight,
                    styleUtils.containerWidth,
                    styleUtils.ovfHidden,
                    {
                        maxWidth: contentMaxWidth,
                    },
                    style,
                ], ...rest }, children)));
    }
    return (React.createElement(Column, { flex: true, style: style, ...rest }, children));
};
export default PageBody;
